import { useEffect } from 'react'
import { EventNames } from '../../types/misc.types'
import { trackEvent } from '../../utils/appBridge'
import BottomSheetContent from './BottomSheetContent'
import { MUTUAL_FUND_DETAIL_IMAGE_URL } from '../../constants'
import { HelpDialogPassage } from './HelpDialogPassage'

type BottomSheetWrapperPropTypes = {
  onDismiss: () => void
  ScreenName: string
}

const BODY_CLASS = "text-[#6a6e6e] text-sm font-normal font-['Matter'] leading-[21px]"

const PASSAGES = [
  "Rolling returns measure a fund's average returns over an observation period (we've taken 3 years).",
  'For example, a 3Y rolling returns is calculated by measuring 3 year returns everyday over the observation period, and averaging them out.',
  'This provides a better picture of how the mutual fund performs in the long term.'
] as const

export const RRBottomSheet = ({ onDismiss, ScreenName }: BottomSheetWrapperPropTypes) => {
  const heading = 'Rolling Returns'
  useEffect(() => {
    trackEvent({
      eventName: EventNames.KnowMoreBottomSheetLoad,
      payload: {
        eventId: heading,
        ScreenName
      }
    })
  }, [])
  return (
    <BottomSheetContent
      logoSrc={`${MUTUAL_FUND_DETAIL_IMAGE_URL}/rolling-returns-bottom-sheet.svg`}
      heading={heading}
      onDismiss={onDismiss}
    >
      <div className='flex flex-col gap-4'>
        {PASSAGES.map((passage) => (
          <HelpDialogPassage key={passage} accessibleLabel={passage}>
            <span className={BODY_CLASS}>{passage}</span>
          </HelpDialogPassage>
        ))}
      </div>
    </BottomSheetContent>
  )
}
